import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

export default function CTASection() {
  return (
    <div className="bg-desert-gradient rounded-lg p-8 md:p-12 text-center shadow-brand-elevated">
      <div className="max-w-2xl mx-auto">
        <h2 className="font-headline text-3xl md:text-4xl font-bold text-white mb-4">
          Still Have Questions?
        </h2>
        <p className="font-body text-lg text-white/90 mb-8">
          Our desert patio experts are ready to help. Get personalized answers and a free quote for your specific needs.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            href="/request-quote"
            className="inline-flex items-center justify-center px-8 py-4 bg-white text-secondary font-body font-semibold rounded-lg hover:bg-cornsilk transition-brand shadow-cta-glow hover:shadow-cta-glow-hover"
          >
            <Icon name="DocumentTextIcon" size={20} className="mr-2" />
            Request Free Quote
          </Link>
          <Link
            href="/contact"
            className="inline-flex items-center justify-center px-8 py-4 bg-transparent border-2 border-white text-white font-body font-semibold rounded-lg hover:bg-white/10 transition-brand"
          >
            <Icon name="PhoneIcon" size={20} className="mr-2" />
            Contact Us
          </Link>
        </div>
      </div>
    </div>
  );
}